// extracted by mini-css-extract-plugin
export default {"root":"Logo_root__++S64","rootTypeBrandBanner":"Logo_rootTypeBrandBanner__Bg3XI","image":"Logo_image__G4zNH","imageTypeBrandBunner":"Logo_imageTypeBrandBunner__rlD5v"};